<template>
  <div>
    <div id="SumCustomerScanDetailed"></div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "SumCustomerScanDetailed",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // mappedData: null,

      // dummyData: [
      //   { category: "Electronics", value: 150 },
      //   { category: "Automotive", value: 90 },
      //   { category: "Retail", value: 120 },
      //   { category: "Healthcare", value: 75 },
      //   { category: "Education", value: 110 },
      // ],

      chart: null,
      pieSeries: null,
      noDataLabel: null,
      colors: ["#ACF9FF", "#F2809F", "#80F2AC", "#80B2EF", "#F2BC80"],
      innerLabel: null,
      highest: null,
    };
  },
  watch: {
    chartData: {
      handler(newData) {
        this.updateChart(newData);
      },
      immediate: true,
    },
  },
  mounted() {
    this.createChart();
    // this.updateMaxValueLabel();
    // this.updateChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    createChart() {
      // console.log("🔵 Creating chart...", this.chart);

      this.chart = am4core.create("SumCustomerScanDetailed", am4charts.PieChart);
      this.chart.innerRadius = am4core.percent(45);
      this.chart.radius = am4core.percent(55);
      // this.chart.seriesContainer.dx = 30;
      this.chart.seriesContainer.dy = -60;

      this.pieSeries = this.chart.series.push(new am4charts.PieSeries());
      this.pieSeries.dataFields.value = "value";
      this.pieSeries.dataFields.category = "label";
      this.pieSeries.slices.template.propertyFields.fill = "color";
      this.pieSeries.labels.template.disabled = true;
      this.pieSeries.ticks.template.disabled = true;
      this.pieSeries.slices.template.tooltipText =
        "{category}: {value} ({value.percent.formatNumber('#.0')}%)";
      this.pieSeries.tooltip.getFillFromObject = false;
      this.pieSeries.tooltip.background.fill = am4core.color("#000");
      this.pieSeries.tooltip.label.fill = am4core.color("#fff");

      this.chart.legend = new am4charts.Legend();
      // this.chart.legend.position = "bottom";
      this.chart.legend.position = "absolute";
      this.chart.legend.x = 30;
      this.chart.legend.y = 470;
      // this.chart.legend.horizontalCenter = "middle";
      this.chart.legend.valueLabels.template.disabled = true;
      this.chart.legend.dataFields.name = "label";
      this.chart.legend.maxWidth = am4core.percent(100);
      // this.chart.legend.contentAlign = "center";
      this.chart.legend.useDefaultMarker = true;
      // this.chart.legend.labels.template.maxWidth = 150;
      // this.chart.legend.itemContainers.template.marginBottom = 275;
      // this.chart.legend.itemContainers.template.wrap = true;
      // this.chart.legend.layout = "horizontal";
      this.chart.legend.itemContainers.template.width = am4core.percent(20);
      // this.chart.legend.itemContainers.template.marginRight = 10;
      // this.chart.legend.itemContainers.template.marginLeft = 50;

      // Handle legend click
      this.chart.legend.itemContainers.template.events.on("toggled", () => {
        setTimeout(() => {
          this.updateMaxValueLabel();
        }, 10);
      });

      //   // const item = ev.target.dataItem;
      //   // const series = item.dataContext;

      //   // console.log("Legend toggled:", series.label);
      //   // console.log("Is visible?", item.visible);

      // this.pieSeries.dataItems.each((dataItem) => {
      //   dataItem.events.on("hidden", this.updateMaxValueLabel());
      //   dataItem.events.on("shown", this.updateMaxValueLabel());
      // });

      // this.pieSeries.slices.each((slice) => {
      //   slice.events.on("hide", () => this.updateMaxValueLabel());
      //   slice.events.on("show", () => this.updateMaxValueLabel());
      // });

      // Reattach slice listeners after data update
      // this.pieSeries.slices.each((slice) => {
      //   slice.events.off("propertychanged");
      //   slice.events.on("propertychanged", (ev) => {
      //     if (ev.property === "isHidden") {
      //       setTimeout(() => {
      //         this.updateMaxValueLabel();
      //       }, 10);
      //     }
      //   });
      // });

      // this.chart.legend.itemContainers.template.events.on("toggled", (ev) => {
      // });

      this.innerLabel = this.chart.seriesContainer.createChild(am4core.Label);
      this.innerLabel.horizontalCenter = "middle";
      this.innerLabel.verticalCenter = "middle";
      this.innerLabel.fontSize = 20;
      this.innerLabel.textAlign = "middle";

      this.createNoDataLabel();
      this.updateChart(this.chartData);
      // this.updateChart(this.dummyData);
    },
    createNoDataLabel() {
      if (!this.chart) return;

      this.noDataLabel = this.chart.createChild(am4core.Label);
      this.noDataLabel.align = "center";
      this.noDataLabel.valign = "middle";
      // this.noDataLabel.paddingBottom = 30;
      this.noDataLabel.verticalCenter = "middle";
      this.noDataLabel.horizontalCenter = "middle";
      this.noDataLabel.role = "noDataLabel";
      this.noDataLabel.x = am4core.percent(50);
      this.noDataLabel.y = am4core.percent(50);
      this.noDataLabel.isMeasured = false;
      this.noDataLabel.html = `
        <div class="chart-no-data">
          <span>0</span>
          <span>No Data</span> 
        </div>
        `;
      this.noDataLabel.hide();

      // this.noDataLabel2 = this.chart.createChild(am4core.Label);
      // this.noDataLabel2.align = "center";
      // this.noDataLabel2.verticalCenter = "middle";
      // this.noDataLabel2.role = "noDataLabel2";
      // this.noDataLabel2.html = `
      //   <div class="donut instalment4">
      //     <div class="donut-default"></div>
      //     <div class="donut-line"></div>
      //     <div class="donut-text">
      //         <div class="zero">0</div>
      //         <div>No Data</div>
      //     </div>
      //     <div class="donut-case"></div>
      //   </div>
      //   `;
      // // this.noDataLabel2.html = `
      // //   <p style="font-weight: bold; font-size: 1.5rem;">No Data Available.</p>
      // //   <p style="margin-top: -0.5rem">Please choose another time or option</p>`;
      // this.noDataLabel2.hide();
    },
    toggleNoDataLabel(data) {
      // console.log("Mapped data:", data);
      const hasData = data && data.some((item) => parseInt(item.value, 10) > 0);

      if (!hasData) {
        this.noDataLabel.show();
        this.chart.seriesContainer.hide();
        this.chart.data = [];
        this.chart.legend.hide();
      } else {
        this.noDataLabel.hide();
        this.chart.seriesContainer.show();
        this.chart.legend.show();
      }
    },
    updateMaxValueLabel() {
      // let maxValue = -Infinity;
      // // let maxValue = this.highest.value;
      // console.log("max value:", maxValue);

      // let maxCategory = this.highest.label;

      // console.log("Data pie series:", this.pieSeries);

      // // this.pieSeries.dataItems.each((dataItem) => {
      // //   if (!dataItem.visible) return;

      // //   let value = dataItem.values.value.value;
      // //   if (value > maxValue) {
      // //     maxValue = value;
      // //     maxCategory = dataItem.dataContext.label;
      // //   }
      // // });

      // // this.pieSeries.dataItems.each((dataItem) => {
      // //   const slice = dataItem.slice;
      // //   if (slice && slice.isHidden) return;

      // //   const value = dataItem.values.value.value;
      // //   if (value > maxValue) {
      // //     maxValue = value;
      // //     maxCategory = dataItem.dataContext.label;
      // //   }
      // // });

      // this.pieSeries.dataItems.each((dataItem) => {
      //   const slice = dataItem.slice;
      //   if (!slice || slice.isHidden) return;

      //   const value = dataItem.values.value.value;
      //   if (value > maxValue) {
      //     maxValue = value;
      //     maxCategory = dataItem.dataContext.label;
      //   }
      // });

      // if (maxValue === -Infinity && this.highest) {
      //   maxValue = this.highest.value;
      //   maxCategory = this.highest.label;
      // }

      // // this.innerLabel.text =
      // //   maxValue > -Infinity ? `Max:\n${maxCategory} (${maxValue})` : "No data";

      // // if (maxValue > -Infinity) {
      // //   this.innerLabel.text = `Max:\n${maxCategory} (${maxValue})`;
      // // } else {
      // //   this.innerLabel.text = "No data";
      // // }

      // this.innerLabel.text =
      //   maxValue > 0 ? `Max:\n${maxCategory} (${maxValue})` : "No data";

      if (!this.pieSeries || !this.innerLabel) return;

      // console.log("Chart from updateMaxValueLabel:", this.chart.data);

      // let initialTotal = this.chart.data.reduce(
      //   (sum, item) => sum + item.value,
      //   0
      // );
      // let highest = this.chart.data.reduce(
      //   (prev, current) => (current.value > prev.value ? current : prev),
      //   { label: "", value: 0 }
      // );

      // this.innerLabel.text =
      //   highest.value > 0
      //     ? `[bold]${highest.label}[/]\n${(
      //         (highest.value / initialTotal) *
      //         100
      //       ).toFixed(2)}%`
      //     : "";

      let visibleSlices = this.pieSeries.slices.values
        .filter((slice) => !slice.isHiding && slice.visible)
        .map((slice) => ({
          label: slice.dataItem.dataContext.label,
          value: slice.dataItem.values.value.value,
        }));

      if (visibleSlices.length === 0) {
        this.innerLabel.text = "";
        return;
      }

      // let total = visibleSlices.reduce((sum, item) => sum + item.value, 0);
      let topVisible = visibleSlices.sort((a, b) => b.value - a.value)[0];

      // this.innerLabel.text = `
      // [bold]${topVisible.label}[/]
      // \n
      // ${((topVisible.value / total) * 100).toFixed(2)}%`;

      // this.innerLabel.text = `${((topVisible.value / total) * 100).toFixed(
      //   2
      // )}%\n[bold]${topVisible.label}[/]`;

      this.innerLabel.text = `${topVisible.value}\n[bold]${topVisible.label}[/]`;
    },
    updateChart(data = this.chartData) {
      // console.log("🔵🔵 Updating chart...", this.chart);
      console.log("Data chart:", this.chartData);
      if (!this.chart) return;

      let mappedData = data.map((item, index) => ({
        label: item.category,
        value: item.value,
        color: this.colors[index % this.colors.length],
      }));

      // this.mappedData = mappedData;

      this.toggleNoDataLabel(mappedData);
      this.chart.data = mappedData;

      // this.chart.legend.data = [];
      // if (this.chart && this.chart.legend) {
      // console.log("Chart from updateChart:", this.chart.data);

      this.chart.legend.data = mappedData.filter((item) => item.value > 0);
      // }

      // this.chart.legend.invalidateRawData();

      // console.log(
      //   "Filtered legends:",
      //   mappedData.filter((item) => item.value > 0)
      // );

      // let total = mappedData.reduce((sum, item) => sum + item.value, 0);
      let highest = mappedData.reduce(
        (prev, current) => (current.value > prev.value ? current : prev),
        { label: "", value: 0 }
      );

      // this.innerLabel.text =
      //   highest.value > 0
      //     ? `[bold]${highest.label}[/]\n${(
      //         (highest.value / total) *
      //         100
      //       ).toFixed(2)}%`
      //     : "";

      // this.innerLabel.text =
      //   highest.value > 0
      //     ? `${((highest.value / total) * 100).toFixed(2)}%\n[bold]${
      //         highest.label
      //       }[/]`
      //     : "No Data";

      this.innerLabel.text =
        highest.value > 0 ? `${highest.value}\n[bold]${highest.label}[/]` : "No Data";

      // 🔁 Reattach listeners to updated slices
      // this.pieSeries.slices.each((slice) => {
      //   slice.events.off("propertychanged"); // prevent duplicates
      //   slice.events.on("propertychanged", (ev) => {
      //     if (ev.property === "isHidden") {
      //       setTimeout(() => {
      //         this.updateMaxValueLabel();
      //       }, 10); // optional: let visibility settle
      //     }
      //   });
      // });

      // 🧠 Update initial max value in center
      // this.updateMaxValueLabel();

      // this.$nextTick(() => {
      //   this.updateMaxValueLabel();
      // });
    },
  },
};
</script>

<style>
#SumCustomerScanDetailed {
  width: 100%;
  height: 600px;
  transform: translate3d(0, 0, 0);
}

#SumCustomerScanDetailed g[aria-label="Chart"] + g g[aria-labelledby] {
  opacity: 0;
}

#SumCustomerScanDetailed .chart-no-data {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 16px solid #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 24px;
  font-weight: 600;
}

#SumCustomerScanDetailed .chart-no-data span:first-child {
  font-size: 48px;
  font-weight: 700;
}

.donut {
  position: relative;
  width: 200px;
  height: 200px;
}

.donut-default {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.donut-white {
  width: 70%;
  height: 70%;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.donut-line {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.donut-text {
  top: 25px;
  left: 25px;
  width: 150px;
  height: 150px;
  background: #fff;
  position: absolute;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  z-index: 3;
}

.instalment4 .donut-case {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #d5d5d5;
  position: absolute;
  top: 0;
  left: 0;
  background-clip: border-box;
  overflow: hidden;
}

.donut-text div {
  color: #383838;
  font-weight: bold;
}

.donut-text .zero {
  font-size: 27px;
}
</style>
